import { useIntl } from 'react-intl';
import { ActionRow, AlertModal, Button } from '@openedx/paragon';
import { Info } from '@openedx/paragon/icons';
import { loginRedirectUrl } from 'helpers/utils/cookie';
import { messages } from './session-invalid-alert-modal.messages';
import { SessionInvalidAlertModalProps } from './types';

export const SessionInvalidAlertModal = ({
  isOpen,
}: SessionInvalidAlertModalProps) => {
  const { formatMessage } = useIntl();

  const redirectToLogin = () => window.location.replace(loginRedirectUrl());

  return (
    <AlertModal
      title={formatMessage(messages['checkout.session.invalid.alert.title'])}
      variant="danger"
      isOpen={isOpen}
      icon={Info}
      footerNode={
        <ActionRow>
          <Button variant="danger" onClick={redirectToLogin}>
            {formatMessage(messages['checkout.session.invalid.alert.button'])}
          </Button>
        </ActionRow>
      }
    >
      <p>{formatMessage(messages['checkout.session.invalid.alert.message'])}</p>
    </AlertModal>
  );
};
